import { get, put, del } from '../identity';

export const createAdminGetEndpoint = (path) => (data) => get(path, { data });

export const createAdminPutEndpoint = (path) => (data) => put(path, { data });

export const createAdminDeleteEndpoint = (path) => (data) => del(path, { data });
